<template>
  <div class="">
    <m-product-wrapper :dirty-router-after-page-change="false" :product-brands="productBrands"
                       :product-categories="productCategories">
      <template v-slot="{products,pagination,changePageFunction}">
        <swiper :breakpoints="swiperOptions.breakpoints" :slides-per-view="swiperOptions.slidesPerView" :navigation="true" :modules="modules" ref="mySwiper">

          <swiper-slide v-for="product in removeCurrentProduct(products)" :key="product.id">
            <m-c301 :product="product"
                    :digitalShoppingCartBadge="digitalShoppingCartBadge"
                    :physicalShoppingCartBadge="physicalShoppingCartBadge"
            />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </template>
    </m-product-wrapper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import {EffectFade} from 'swiper';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import {Navigation} from "swiper";
import mC301 from "../../Product/Card/C301";
import mProductWrapper from "../../Wrappers/ProductWrapper";

export default {
  name: "RelatedProducts-301",
  props: {
    title: {
      type: String,
      default: "محصولات مرتبط"
    },
    digitalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    physicalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    productBrands: {
      default: null
    },
    productCategories: {
      default: null
    },
    ignoreProduct: {
      default: () => {
        return []
      }
    },
  },
  components: {Swiper, SwiperSlide, mC301, mProductWrapper},
  methods: {
    removeCurrentProduct(products) {
      return products.filter(item => this.ignoreProduct.indexOf(item.id) === -1)
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          100: {
            slidesPerView: 1,
          },
          500: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          765: {
            slidesPerView: 3,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          }
        }
      },
    };
  },
  setup() {
    return {
      modules: [Navigation, EffectFade],
    };
  },
}
</script>

<style scoped>
.slider-row {
  padding-top: 20px;
  margin-left: 30px;
  margin-right: 30px;
}

.slider-controls {
  border-bottom: 1px solid #c4c4c4;
}
</style>